const doc = [["event-2026-04_asx-card", "2026-01-04", "2025-12-28"]];
module.exports = doc.length <= 1 ? doc[0] : doc;